import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Racine du site (`foliesboutik.be/`).
 *
 * Un client qui tape l'adresse nue doit arriver à la boutique, pas sur l'écran
 * de connexion du personnel : avant ce composant, `/` renvoyait vers `/dashboard`,
 * que `ProtectedRoute` transformait en `/login` pour tout visiteur non connecté.
 *
 * Un membre de l'équipe déjà connecté garde son point d'entrée (`/dashboard`) ;
 * `/login` et `/pos` restent accessibles directement.
 */
export default function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();

  // Sans jeton en localStorage, `loading` retombe à false dès le premier rendu :
  // le client ne voit rien d'autre que la boutique.
  if (loading) return null;

  return <Navigate to={isAuthenticated ? '/dashboard' : '/shop'} replace />;
}
